<div class="rev-custom-tooltip-content">
	<h5 class="margin-top-0">Day/Time Preferences</h5>
	@if (patientSchedulingPreference) {
		<dl class='row margin-0'>
			<dt class="col-md-3">Sunday</dt>
			<dd class="col-md-9">{{ patientSchedulingPreference.sunday }}</dd>
			<dt class="col-md-3">Monday</dt>
			<dd class="col-md-9">{{ patientSchedulingPreference.monday }}</dd>
			<dt class="col-md-3">Tuesday</dt>
			<dd class="col-md-9">{{ patientSchedulingPreference.tuesday }}</dd>
			<dt class="col-md-3">Wednesday</dt>
			<dd class="col-md-9">{{ patientSchedulingPreference.wednesday }}</dd>
			<dt class="col-md-3">Thursday</dt>
			<dd class="col-md-9">{{ patientSchedulingPreference.thursday }}</dd>
			<dt class="col-md-3">Friday</dt>
			<dd class="col-md-9">{{ patientSchedulingPreference.friday }}</dd>
			<dt class="col-md-3">Saturday</dt>
			<dd class="col-md-9">{{ patientSchedulingPreference.saturday }}</dd>
		</dl>
	}
</div>
